export default {
    props: {
        value: {
            type: Boolean,
            default: false,
        },
        modelValue: {
            default: false,
        },
        onClick: {
            type: Function,
            default: () => {},
        },
        name: {
            type: String,
            required: true,
        },
        desc: {
            type: String,
            required: true,
        },
    },
    model: {
        prop: "modelValue",
        event: "change",
    },
    data() {
        return {};
    },
    computed: {
        shouldBeChecked() {
            console.log("value", this.value);
            console.log("this.modelValue", this.modelValue);
            return this.modelValue == this.value;
        },
    },
    created() {},
    mounted() {
        console.log("this.value", this.value);
    },
    methods: {
        updateInput(value) {
            console.log("value", value);
            console.log("this.value", this.value);

            this.value = !this.value;

            // this.$emit("change", this.value);
        },
    },
};
